import * as React from 'react';
import { MijnFnvLink } from '../pages/interfaces/PageInterfaces';
import { Link } from 'react-router-dom';
import { StringHelpers } from '../../helpers/StringHelpers';

export interface MijnFNVHandigeLinksProps {
    MijnFnvLinks : MijnFnvLink[];
    title: string;
    dataContext?: any;
    additionalCssClass? : string;
}

export class MijnFNVHandigeLinks extends React.Component<MijnFNVHandigeLinksProps> {
    render () {
        return <>
            <div className={"fnv-form__container-form widget mijn-fnv-form__handige-links " + (this.props.additionalCssClass || "")}>
                <div className="form__react">
                    {this.props.title !== "" ? <h2 className="form__panel-title">{this.props.title}</h2> : null}
                    <ul className="handige-links__list">
                        {(this.props.MijnFnvLinks || []).map((link, index) => {

                            let linkUrl = link.Link;
                            if (this.props.dataContext) {                                
                                linkUrl = StringHelpers.replacePropertiesInUrl(linkUrl, this.props.dataContext.result || this.props.dataContext);
                            }
                            if ((linkUrl || "").indexOf("~") == 0) {
                                linkUrl = (linkUrl || "").slice(1);      
                            }

                            return <li key={"handige-links-widget" + index} 
                                className={"handige-links__list-item"}>                                
                                {link.IsInternalMijnFNVLink || false ? <Link 
                                    to={linkUrl} className={"link__single " + link.CssClass || ""}
                                    target={link.OpenLinkInNewTab ? "_blank" : ""}
                                    >
                                    <span className="link__content">
                                        <span className="link__content-title">{link.Titel}</span>
                                        <span className="link__content-description">{link.LinkDescription}</span>
                                    </span>                                    
                                    <span className="icon icon-open-chevron-right"></span>
                                </Link>
                                :
                                <a className={"link__single " + link.CssClass || ""} 
                                    href={linkUrl} 
                                    target={link.OpenLinkInNewTab ? "_blank" : ""}>
                                    <span className="link__content">
                                        <span className="link__content-title">{link.Titel}</span>
                                        <span className="link__content-description">{link.LinkDescription}</span>
                                    </span>                                    
                                    <span className="icon icon-open-chevron-right"></span>
                                </a>
                                }
                            </li>;
                        })}
                    </ul>
                </div>
            </div>
        </>;
    }
}